import * as Sentry from '@sentry/react';
import { ChunkLoadErrorFallback } from '../Abstracts/ErrorFallback/ChunkLoadErrorFallback/ChunkLoadErrorFallback';

export function ChunkErrorBoundary({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <Sentry.ErrorBoundary
      fallback={<ChunkLoadErrorFallback />}
      beforeCapture={(scope, error) => {
        if (error instanceof Error) {
          if (error.name === 'ChunkLoadError') {
            scope.setTag('boundary', 'chunk_load');
            scope.setTag('sentry_error_name', error.name);
            scope.setLevel('warning');
            scope.setFingerprint(['chunk-load-error']);
          } else {
            scope.setTag('boundary', 'chunk_fatal');
            scope.setTag('sentry_error_name', error.name);
            scope.setLevel('fatal');
            scope.setFingerprint(['chunk-error']);
          }
        }
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
